import { HTTPClient } from '@abaco/web-common/src/HTTP';
import { PagedResults, PagingParams } from '@abaco/web-common/src/Paging';

export default class WorkerApi {

    private http: HTTPClient;
    private rootPath: string;

    constructor(http: HTTPClient, rootPath: string) {
        this.http = http;
        this.rootPath = rootPath;
    }

    public async getWorkers(pk_cuaa: number, paging: PagingParams, filter: string | null): Promise<PagedResults<Worker>>{
        const res = await this.http.get(`${this.rootPath}/v1/plots/subjects/${pk_cuaa}/dictionary_workers`, {
            params: {
                offset: paging.offset,
                count: paging.count,
                filter: filter ? `^subject_full_name like ${filter.toUpperCase()}` : undefined
            }
        })

        return res.data;
    }

}
